document.addEventListener("DOMContentLoaded", function () {
    const mediaQuery = window.matchMedia("(min-width: 768px) and (max-width:1118px)");

    if (mediaQuery.matches) {
        setTimeout(() => {
            const pushboxes = document.querySelectorAll('.columnmarker .component-pushbox');
            let maxHeight = 0;
            pushboxes.forEach(pushbox => {
                const height = pushbox.offsetHeight;
                if (height > maxHeight) {
                    maxHeight = height;
                }
            });

            pushboxes.forEach(pushbox => {
                pushbox.style.setProperty('height', maxHeight + 'px', 'important');
            });

        }, 700);
    }
});
jQuery(function () {
    $('.section.vspace-sm').each(function () {
        if ($(this).find('.promoComponentRedsign').length) {
            $(this).addClass('promoComponent');
        }
    });
    // Select all the promoComponent elements under .main_content
    const promoComponents = document.querySelectorAll('.main_content .promoComponent');
    if (promoComponents.length > 0) {
        // Get the last promoComponent
        const lastPromoComponent = promoComponents[promoComponents.length - 1];
        const lastPromoSection = lastPromoComponent.closest('.section');

        if (lastPromoSection) {
            lastPromoSection.classList.add('marginBottom_lastPromo');
        }
    }
    async function setAlignment() {
        await delay(1000);
        setbottomAlignment();
    }

    equal_height_cards();


    setAlignment();
    equal_height_text_elements();
});
$(window).on('load', function () {

    async function setAlignment() {
        await delay(1000);
        setbottomAlignment();
    }
    equal_height_cards();


    setAlignment();
    equal_height_text_elements();
});
$(window).resize(function () {
    async function setAlignment() {
        await delay(1000);
        setbottomAlignment();
    }
    equal_height_cards();


    setAlignment();
    equal_height_text_elements();
});

function delay(ms) {
    return new Promise(resolve =>
        setTimeout(resolve, ms));
}

function equal_height_cards() {
    $(".gapincard").not('.gapinInfocard').find('.Promobox--SingleCard > .component-pushbox').height("unset");
    $('.Promobox--SingleCard').height("unset");
    if ($(window).width() > 767) {
        $(".gapincard").not('.gapinInfocard').each(function () {
            var maxHeight = 0;
            $(this).find('.Promobox--SingleCard > .component-pushbox').each(function () {
                if ($(this).parent().hasClass("promofullWidthImage")) { } else {
                    var height = $(this).outerHeight(true);
                    if (height > maxHeight) {
                        maxHeight = height;
                    }
                }

            });
            $(this).find('.Promobox--SingleCard > .component-pushbox').each(function () {
                $(this).height(maxHeight);
            });
        });
        $(".gapin-promolist").each(function () {
            var maxHeightpromo = 0;
            $(this).find('.Promobox--SingleCard > .component-pushbox').each(function () {
                var height = $(this).outerHeight(true);
                if (height > maxHeightpromo) {
                    maxHeightpromo = height;
                }
            });

            $(this).find('.Promobox--SingleCard > .component-pushbox').each(function () {
                $(this).height(maxHeightpromo);

            });

        });

    }


}

function setbottomAlignment() {
    if ($(window).width() > 767) {
        $(".Promobox--SingleCard > .component-pushbox").each(function () {


            var $pushbox = $(this),
                totalHeight = $(this).outerHeight(true),
                contentHeight = 0,
                difference = 0;
            // Calculate content height
            $pushbox.find(".promocontent-div").children()
                .filter(function () {
                    return $(this).css("position") !== "absolute";
                }).each(function () {
                    contentHeight += $(this).outerHeight(true);

                });

            // Calculate difference
            difference = Math.ceil(totalHeight - contentHeight);

            if (contentHeight > 0 && difference > 0) {
                $(this).find(".pushbox-button").css("margin-top", difference);
                //    $(this).find(".js-align-bottom").css("margin-top", difference);
            }

        });
    }
}


function equal_height_text_elements() {
    // Reset the height of promo-heading, promo-desc, and promo-subheading
    $(".gapincard").not('.gapinInfocard').find('.Promobox--SingleCard .promo-heading, .Promobox--SingleCard .promo-desc, .Promobox--SingleCard .promo-subheading').css("height", "unset");


    if ($(window).width() > 767) {
        $(".gapincard").not('.gapinInfocard').each(function () {
            // Equal height for promo-heading
            var maxHeadingHeight = 0;
            //$(this).find('.Promobox--SingleCard .promo-heading').each(function () {
            //    var height = $(this).outerHeight(true);
            //    if (height > maxHeadingHeight) {
            //        maxHeadingHeight = height;
            //    }
            //});
            //$(this).find('.Promobox--SingleCard .promo-heading').each(function () {
            //    $(this).css("height", maxHeadingHeight);
            //});

            // Equal height for promo-desc
            var maxDescHeight = 0;
            $(this).find('.Promobox--SingleCard .promo-desc').each(function () {
                var height = $(this).outerHeight(true);
                if (height > maxDescHeight) {
                    maxDescHeight = height;
                }
            });
            $(this).find('.Promobox--SingleCard .promo-desc').each(function () {
                $(this).css("height", maxDescHeight);
            });

            // Equal height for promo-subheading
            var maxSubheadingHeight = 0;
            //$(this).find('.Promobox--SingleCard .promo-subheading').each(function () {
            //    var height = $(this).outerHeight(true);
            //    if (height > maxSubheadingHeight) {
            //        maxSubheadingHeight = height;
            //    }
            //});
            //$(this).find('.Promobox--SingleCard .promo-subheading').each(function () {
            //    $(this).css("height", maxSubheadingHeight);
            //});

            $(this).find('.CTA_button_primary').each(function () {
                var $current = $(this);
                var hasButtonInSiblings = $(this).siblings().find('.pushbox-button').length > 0;

                if (!hasButtonInSiblings) {
                    $current.find('.js-align-bottom').css("margin-top", "0");
                }
            });
        });
    }
}



jQuery(function () {
    $(document).on('keydown', function (event) {
        if (event.key === 'Enter' || event.keyCode === 13) {
            // Get the currently focused element
            var focusedElement = $(document.activeElement);
            focusedElement.click();

        }
    });
});
